import Vue from "vue";
import VueRouter from "vue-router";
// import store from "@/store/store";
Vue.use(VueRouter);

const routes = [


    ///////////////////ACCOUNT_LAYOUT///////////////////////

    {
        path: '/account/',
        name: 'AccountDashboard',
        meta: {layout: 'account'},
        component: () => import('../views/account/AccountDashboard'),
    },
    {
        path: '/account/account-view',
        name: 'AccountView',
        meta: {layout: 'account'},
        component: () => import('../views/account/AccountView'),
    },
    {
        path: '/account/account-statement',
        name: 'AccountStatement',
        meta: {layout: 'account'},
        component: () => import('../views/account/AccountStatement'),
    },
    {
        path: '/account/account-activities',
        name: 'AccountActivities',
        meta: {layout: 'account'},
        component: () => import('../views/account/AccountActivities'),
    },
    {
        path: '/account/beneficiary-management',
        name: 'BeneficiaryManagement',
        meta: {layout: 'account'},
        component: () => import('../views/account/BeneficiaryManagement'),
    },
    {
        path: '/account/support',
        name: 'CustomerSupport',
        meta: {layout: 'account'},
        component: () => import('../views/account/CustomerSupport'),
    },


    ///////////////////////////////PAYMENTS/////////////////////////////////////

    {
        path: '/payments/funds-transfer-multiple',
        name: 'FundsTransferMultiple',
        meta: {layout: 'payments'},
        component: () => import('../views/payments/FundsTransferMultiple'),
    },

    {
        path: '/payments/funds-transfer-single',
        name: 'FundsTransferSingle',
        meta: {layout: 'payments'},
        component: () => import('../views/payments/FundsTransferSingle'),
    },

    {
        path: '/payments/auth-request',
        name: 'PaymentAuthRequest',
        meta: {layout: 'payments'},
        component: () => import('../views/payments/PaymentAuthRequest'),
    },


    ////////////////////////ADMIN_LAYOUT////////////////////////////
    {
        path: '/admin/stats',
        name: 'AdminStats',
        meta: {layout: 'admin'},
        component: () => import('../views/admin/Stats')
    },

    {
        path: '/admin/users',
        name: 'AdminUsers',
        meta: {layout: 'admin'},
        component: () => import('../views/admin/Users')
    },

{
        path: '/admin/companies',
        name: 'AdminCompanies',
        meta: {layout: 'admin'},
        component: () => import('../views/admin/Companies')
    },



    /////////////////////AUTH_LAYOUT//////////////////////////
    {
        path: '/logon',
        name: 'Logon',
        meta: {layout: 'auth'},
        component: () => import('../views/auth/Logon'),
    },
    {
        path: '/',
        name: 'MainDashboard',
        meta: {layout: 'auth'},
        component: () => import('../views/dashboard/Dashboard')
    },
    {
        path: '/register',
        name: 'Register',
        meta: {layout: 'auth'},
        component: () => import('../views/auth/Register')
    },
    {
        path: '/reset-password',
        name: 'PasswordReset',
        meta: {layout: 'auth'},
        component: () => import('../components/form/PasswordReset'),
    },
];



Vue.use(VueRouter);


const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});


router.beforeEach((to, from, next) => {
    // redirect to login page if not logged in and trying to access a restricted page
    const publicPages = ['/logon', '/reset-password'];
    const authRequired = !publicPages.includes(to.path);
    const loggedIn = localStorage.getItem('token');
    //const loggedIn = this.$store.state.auth.response;
    if (authRequired && !loggedIn) {
        return next('/logon');
    }
    return next()

});

export default router;
